module.exports = __webpack_public_path__ + "static/carlsbad-4-f519e526792a5659ca735476bfe1b2de.png";